import ApplicationController from './application_controller';

// Generic sidebar-picker controller: when the user picks an option in an Impulse
// select (awc-autocomplete:commit), fetch an HTML fragment from `endpoint?record_id=<id>` and
// inject it into the `preview` target. Used by reference-panel widgets (prior
// notes, evaluations, assessments, alerts) that share the same "pick → show
// inline" pattern. The param is deliberately NOT named `id`: these are
// collection routes, and CanCanCan's load_and_authorize_resource treats any
// action with params[:id] as a member action — it would find/authorize! the
// record before the action runs, breaking the graceful "not found" rendering.
//
// Required values/targets:
//   data-sidebar-picker-endpoint-value="/some/path"
//   data-sidebar-picker-target="preview"
export default class extends ApplicationController {
  static targets = ['preview'];
  static values = { endpoint: String };

  async select(event) {
    const id = event.detail?.value;
    if (!id || !this.hasPreviewTarget) return;

    const url = new URL(this.endpointValue, window.location.origin);
    url.searchParams.set('record_id', id);

    this.previewTarget.innerHTML =
      '<div class="text-center p-3"><div class="spinner-border spinner-border-sm" role="status"><span class="sr-only">Loading...</span></div></div>';

    try {
      const res = await fetch(url.toString(), {
        headers: { Accept: 'text/html' },
        credentials: 'same-origin',
      });
      if (!res.ok) throw new Error(`Fetch failed: ${res.status}`);
      this.previewTarget.innerHTML = await res.text();
    } catch {
      this.previewTarget.innerHTML = '<p class="reference-widget__empty mt-3">Couldn\'t load that record.</p>';
    }
  }
}
